import {Contract} from './contract';
import {VehicleBrand} from './vehicleBrand';
import {VehicleType} from "./vehicleType";
import {KmHistory} from "./kmHistory";
import {Procedure} from "./procedure";

export class Vehicle {
    id: string;
    patent: string;
    type: VehicleType = new VehicleType();
    brand: VehicleBrand = new VehicleBrand();
    version: number;
    model: string;
    year: number;
    engineNumber: string;
    registrable: boolean = true;
    center: string;
    contract: Contract = new Contract(null);
    purchaseOrderEntryDate: string;
    purchaseOrderAmount: number;
    purchaseOrderDueDate: string;

    kmHistory: KmHistory = new KmHistory(null);

    kmHistories: KmHistory[] = [];

    procedures: Procedure[] = [];

    procedure: Procedure = new Procedure(null);

    patentPayment: Procedure = new Procedure(null);

    constructor(other ?: Vehicle) {
        if (other) {
            this.id = other.id;
            this.patent = other.patent;
            this.type = new VehicleType(other.type);
            this.brand = new VehicleBrand(other.brand);
            this.version = other.version;
            this.model = other.model;
            this.year = other.year;
            this.engineNumber = other.engineNumber;
            this.registrable = other.registrable;
            this.center = other.center;
            this.contract = new Contract(other.contract);
            this.purchaseOrderEntryDate = other.purchaseOrderEntryDate;
            this.purchaseOrderAmount = other.purchaseOrderAmount;
            this.purchaseOrderDueDate = other.purchaseOrderDueDate;

            this.kmHistory = new KmHistory(other.kmHistory);

            this.kmHistories = other.kmHistories.map((kmHistory) => new KmHistory(kmHistory));
            this.procedures = other.procedures.map((procedure) => new Procedure(procedure));
            this.procedure = new Procedure(other.procedure);

            this.patentPayment = new Procedure(other.patentPayment);
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/vehicle.ts
 **/